import { useState } from "react";
import { toast } from "sonner";
import { BellRing, KeyRound } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/site/FormBits";
import { api, formatApiError } from "@/lib/api";
import { enablePush, disablePush, pushSupported } from "@/lib/push";
import { AvatarUpload } from "@/components/site/AvatarUpload";

export function AccountSettings() {
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  const change = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", pw);
      toast.success("Password updated");
      setPw({ current_password: "", new_password: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  const push = async (on) => {
    try {
      on ? await enablePush() : await disablePush();
      toast.success(on ? "Push notifications enabled on this device" : "Push notifications turned off");
    } catch (err) {
      toast.error(err.message);
    }
  };
  return (
    <div className="flex flex-col gap-6">
    <AvatarUpload />
    <div className="grid md:grid-cols-2 gap-6" data-testid="account-settings">
      <form onSubmit={change} className="bg-white rounded-2xl border border-[#0B2A4A]/10 p-6 flex flex-col gap-4">
        <h3 className="font-semibold text-[#0B2A4A] flex items-center gap-2"><KeyRound className="h-4 w-4" /> Change password</h3>
        <Field label="Current password" htmlFor="pw-current">
          <Input id="pw-current" type="password" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} data-testid="current-password-input" />
        </Field>
        <Field label="New password (8+ characters)" htmlFor="pw-new">
          <Input id="pw-new" type="password" minLength={8} required value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="new-password-input" />
        </Field>
        <button disabled={busy} className="self-start rounded-xl bg-[#0B2A4A] text-[#F5ECD7] px-5 py-2.5 text-sm font-semibold" data-testid="change-password-btn">Update password</button>
      </form>
      <div className="bg-white rounded-2xl border border-[#0B2A4A]/10 p-6 flex flex-col gap-3">
        <h3 className="font-semibold text-[#0B2A4A] flex items-center gap-2"><BellRing className="h-4 w-4" /> Alerts & push notifications</h3>
        <p className="text-sm text-slate-600">In-app alerts always appear under the bell. Turn on push to get alerts on this device even when the site is closed. On iPhone, add the app to your Home Screen first.</p>
        {pushSupported() ? (
          <div className="flex gap-3">
            <button onClick={() => push(true)} className="rounded-xl bg-[#1A9AA8] text-white px-5 py-2.5 text-sm font-semibold" data-testid="settings-enable-push-btn">Enable push</button>
            <button onClick={() => push(false)} className="rounded-xl border border-[#0B2A4A]/20 px-5 py-2.5 text-sm font-semibold" data-testid="settings-disable-push-btn">Turn off</button>
          </div>
        ) : (
          <p className="text-sm text-amber-700" data-testid="push-unsupported">This browser does not support push notifications.</p>
        )}
      </div>
    </div>
    </div>
  );
}
